<template>
  <Transition name="dialog-fade">
    <div v-if="visible" class="dialog-overlay" @click="handleOverlayClick">
      <div class="dialog-container" @click.stop>
        <div class="dialog-body">
          <div class="dialog-icon">
            <i class="bi bi-question-circle"></i>
          </div>
          <p class="dialog-message">{{ message }}</p>
        </div>

        <div class="dialog-footer">
          <button
            class="btn btn-cancel"
            @click="handleCancel"
          >
            {{ cancelText }}
          </button>
          <button
            class="btn btn-confirm"
            @click="handleConfirm"
          >
            {{ confirmText }}
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    message: {
      type: String,
      required: true
    },
    confirmText: {
      type: String,
      default: 'OK'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    closeOnOverlay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false
    }
  },
  mounted() {
    this.visible = true
  },
  methods: {
    handleConfirm() {
      this.visible = false
      setTimeout(() => {
        this.$emit('confirm')
        this.$emit('close')
      }, 200)
    },
    handleCancel() {
      this.visible = false
      setTimeout(() => {
        this.$emit('cancel')
        this.$emit('close')
      }, 200)
    },
    handleOverlayClick() {
      if (this.closeOnOverlay) {
        this.handleCancel()
      }
    }
  }
}
</script>

<style scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}

.dialog-container {
  background: white;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 480px;
  width: 100%;
  overflow: hidden;
}

.dialog-body {
  padding: 40px 32px 32px;
  text-align: center;
}

.dialog-icon {
  margin-bottom: 20px;
}

.dialog-icon i {
  font-size: 56px;
  color: #9C27B0;
  opacity: 0.9;
}

.dialog-message {
  margin: 0;
  font-size: 17px;
  line-height: 1.6;
  color: #333;
  font-weight: 400;
}

.dialog-footer {
  padding: 0 32px 32px;
  display: flex;
  gap: 12px;
  justify-content: center;
}

.btn {
  padding: 14px 40px;
  border-radius: 28px;
  font-size: 16px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 120px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.btn-cancel {
  background: #f5f5f5;
  color: #666;
}

.btn-cancel:hover {
  background: #e8e8e8;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn-confirm {
  background: linear-gradient(135deg, #8B4513 0%, #A0522D 100%);
  color: white;
}

.btn-confirm:hover {
  background: linear-gradient(135deg, #6d3410 0%, #8B4513 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(139, 69, 19, 0.4);
}

/* Animations */
.dialog-fade-enter-active,
.dialog-fade-leave-active {
  transition: opacity 0.2s ease;
}

.dialog-fade-enter-active .dialog-container,
.dialog-fade-leave-active .dialog-container {
  transition: transform 0.2s ease;
}

.dialog-fade-enter-from,
.dialog-fade-leave-to {
  opacity: 0;
}

.dialog-fade-enter-from .dialog-container {
  transform: scale(0.95);
}

.dialog-fade-leave-to .dialog-container {
  transform: scale(0.95);
}

/* Responsive */
@media (max-width: 576px) {
  .dialog-container {
    max-width: 90vw;
  }

  .dialog-header,
  .dialog-body,
  .dialog-footer {
    padding: 16px;
  }

  .dialog-title {
    font-size: 16px;
  }

  .dialog-message {
    font-size: 14px;
  }

  .btn {
    padding: 10px 24px;
    font-size: 14px;
    min-width: 80px;
  }
}
</style>
